import { H4 } from "@/components/ui/Heading";
import { useTranslations } from "next-intl";

export const EmptyPropertyList = () => {
  const t = useTranslations("shared");

  return <H4 className="py-4">{t("words.no-properties-available")}</H4>;
};
